import React, { useRef, useState } from 'react';
import emailjs from '@emailjs/browser';
import { FaPhone } from 'react-icons/fa';
import { IoMailOpen } from "react-icons/io5";
import { FaLocationDot } from "react-icons/fa6";
import toast from 'react-hot-toast';
import useTitle from '../../Hooks/useTitle';

const Contact = () => {
    useTitle("Contact");
    const form = useRef();
    const [errorMessage, setErrorMessage] = useState('');
    const [errorEmail, setErrorEmail] = useState('');
    const [loading, setLoading] = useState(false);

    const sendEmail = (e) => {
        e.preventDefault();
        setErrorMessage('');
        setErrorEmail('');
        setLoading(true);

        // Basic validation
        if (e.target.from_message.value === '') {
            setErrorMessage('Message is required');
            setLoading(false);
            return;
        }
        if (e.target.from_email.value === '') {
            setErrorEmail('Email is required');
            setLoading(false);
            return;
        }

        // Send email using EmailJS
        emailjs.sendForm('service_swj7zlb', 'template_von266c', form.current, 'xBT1ZOMoTkoEJ68lp')
            .then((result) => {
                console.log('Success:', result);
                if (result.status === 200) {
                    toast.success('Message sent successfully');
                    e.target.reset();
                    setLoading(false);
                }
            }, (error) => {
                console.error('Error:', error);
                setErrorMessage('An error occurred. Please try again later.');
                setLoading(false);
            });
    };

    return (
        <div className='px-5 md:px-20 lg:px-32 py-10 max-w-[1400px] m-auto' data-aos='fade-up'>
            <h1 className='text-4xl font-bold text-center mb-10 md:mb-8 lg:mb-8 tracking-widest'>Contact <span className='text-teal-300'>Me</span></h1>
            <div className='flex flex-col md:flex-col lg:flex-row justify-between items-center'>
                <div className='w-full md:w-full lg:w-1/2 mb-10'>
                    {/* Contact Info */}
                    <div className='flex items-center gap-4 mb-5'>
                        <span className='flex items-center justify-center border rounded-full w-10 h-10 bg-white text-black'>
                            <FaLocationDot />
                        </span>
                        <div>
                            <h1 className='text-teal-300 font-bold'>Address</h1>
                            <p className='font-medium text-sm'>Dhanmondi, Dhaka, Bangladesh</p>
                        </div>
                    </div>
                    <div className='flex items-center gap-4 mb-5'>
                        <span className='flex items-center justify-center border rounded-full w-10 h-10 bg-white text-black'>
                            <FaPhone />
                        </span>
                        <div>
                            <h1 className='text-teal-300 font-bold'>Phone</h1>
                            <p className='font-medium text-sm'>01794267010</p>
                        </div>
                    </div>
                    <div className='flex items-center gap-4 mb-5'>
                        <span className='flex items-center justify-center border rounded-full w-10 h-10 bg-white text-black'>
                            <IoMailOpen />
                        </span>
                        <div>
                            <h1 className='text-teal-300 font-bold'>Email</h1>
                            <p className='font-medium text-sm'>web.shakil10@gmail.com</p>
                        </div>
                    </div>
                </div>

                <div className='w-full md:w-full lg:w-1/2'>
                    <form ref={form} onSubmit={sendEmail} className='flex flex-col'>
                        <label className='text-xs font-bold mb-1'>Name</label>
                        <input type="text" placeholder="Your full name" name="from_name" className="outline-none border-b-2 py-1 w-full mb-5 text-sm bg-indigo-950 font-bold" />

                        <label className='text-xs font-bold mb-1'>Email <span className='text-red-500'>*</span></label>
                        <input type="email" placeholder="Your email" name="from_email" className="outline-none border-b-2 py-1 w-full text-sm mb-2 bg-indigo-950 font-bold" />
                        <span className='text-red-500 font-bold text-sm mb-5'>{errorEmail}</span>

                        <input type="text" placeholder="Subject" name="from_subject" className="outline-none border-b-2 py-1 w-full text-sm mb-5 bg-indigo-950 font-bold" />

                        <label className='text-xs font-bold mb-1'>Message <span className='text-red-500'>*</span></label>
                        <textarea className="outline-none border-b-2 py-1 mb-2 bg-indigo-950 font-bold" name='from_message' placeholder="Write your message"></textarea>
                        <span className='text-red-500 font-bold text-sm mb-10'>{errorMessage}</span>

                        <button type="submit" className={`btn btn-md bg-teal-300 font-bold hover:bg-teal-500 text-indigo-950`}>
                            {loading ? 'Sending...' : 'Send'}
                        </button>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default Contact;
